import { Provider } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MockBackendInterceptor } from './mock-backend.interceptor';

export const mockProviders: Provider[] = [
  { provide: HTTP_INTERCEPTORS, useClass: MockBackendInterceptor, multi: true },
];
